import { Box, makeStyles } from "@material-ui/core";
import { fetchListStatisticAssessment, selectFilterAssessment, selectStatisticAssessmentList } from "features/Admin/adminSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartCompareInsideAndOutSide from "./ChartCompareInsideAndOutSide";
import ChartCompareTestInside from "./ChartCompareTestInside";
import ChartCompareTraditionAndModern from "./ChartCompareTraditionAndModern";
import ChartTraditional from "./ChartTraditional";

const ChartAssessment = ({ listAssessment }) => {
  const useStyles = makeStyles({
    container: {
      background: "#FFF",
      boxShadow: "0px 0px 4px 0px #8A8A8A4D",
      padding: "16px",
      marginBottom: 40,
      "& > h1": {
        color: "#08090D",
        fontSize: 22,
        fontWeight: 600,
        marginBottom: 20,
      },
    },
  });
  const classes = useStyles();
  const filter = useSelector(selectFilterAssessment);
  const listStatisticAssessment = useSelector(selectStatisticAssessmentList);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListStatisticAssessment(filter));
  }, [dispatch, filter]);


  return (
    <div>
      <Box className={classes.container}>
      <h1>So sánh tỉ lệ kiểm tra truyền thống và hiện đại</h1>
      <ChartCompareTraditionAndModern data={listStatisticAssessment?.hinhThucDanhGiaBieuDo}  />
    </Box>
      <Box className={classes.container}>
        <h1>Số lượng trại làm kiểm tra truyền thống</h1>
        <ChartTraditional
          data={listAssessment?.truyenThong}
          type="total"
        ></ChartTraditional>
      </Box>
      <Box className={classes.container}>
      <h1>Điểm trung bình trại làm kiểm tra truyền thống</h1>
        <ChartTraditional
          data={listAssessment?.truyenThong}
          type="average"
        ></ChartTraditional>
      </Box>
   
    <Box className={classes.container}>
      <h1>So sánh tỉ lệ kiểm tra bên trong và bên ngoài</h1>
      <ChartCompareInsideAndOutSide data={listStatisticAssessment?.hinhThucDanhGiaBieuDo} />
    </Box>
    <Box className={classes.container}>
      <h1>So sánh tỉ lệ kiểm tra các vấn đề bên trong</h1>
      <ChartCompareTestInside data={listStatisticAssessment?.hinhThucDanhGiaBieuDo} />
    </Box> 
    </div>
  );
};

export default ChartAssessment;
